// Component showcase routes
// Copy from full-version/src/routes/components.jsx when needed

export const ComponentRoutes = [];
